<template>
  <div class="about">
    <h1>{{ $t('hello') }}</h1>
    <h1>This is an about page, the res is:</h1>
    <pre>{{ this.res }}</pre>
  </div>
</template>

<script>
import { getVisitorType } from '@/utils/api';
export default {
  name: 'About',
  data() {
    return {
      res: '',
    }
  },
  created: function () {
    getVisitorType().then(res => {
      // console.log(res);
      this.res = JSON.stringify(res);
    });
  },
  methods: {
  }
};
</script>
